import React, {useEffect} from 'react';
import {Platform, Text, Dimensions} from 'react-native';
import {NavigationContainer} from '@react-navigation/native';
import AppNavigator from './App-Navigator';
import AuthNavigator from './Auth-Navigator';
import {useSelector} from 'react-redux';
import {selectIsLoggedIn} from '../redux/slices/AuthSlice';
import {useDispatch} from 'react-redux';
import {setDispatch, setLandscape} from '../service/network_access';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import {validateToken} from '../service/web_service';
import SplashScreen from '../components/splash';

const config = {
   screens: {
      Home: {
         initialRouteName: 'Login',
         path: 'Login',
         screens: {
            Login: 'LoginScreen',
            DashboardScreen: 'DashboardScreen',
         },
      },
      NotFound: '*',
   },
};
const linking = {
   prefixes: ['https://dev-webtraining.norcat.org/myibt/'],
   config: config,
};
const AppRoute = () => {
   const dispatch = useDispatch();
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const isLoggedIn = useSelector(selectIsLoggedIn);
   const brand = 'NORCAT';
   useEffect(() => {
      const isLandscapeMode =
         Dimensions.get('window').width > Dimensions.get('window').height;
      setLandscape(isLandscapeMode);
      setDispatch(dispatch); // Initializing dispatch for using in Network file.
   }, []);

   useEffect(() => {
      validateToken(dispatch, isLoggedIn);
   }, [isLoggedIn]);

   const [Loading, setLoading] = React.useState(true);
   const isWeb = Platform.OS === 'web';
   React.useEffect(() => {
      if (isWeb) {
         var Timeout = setTimeout(() => {
            setLoading(false);
         }, 2000);
      }

      return () => {
         if (isWeb) {
            clearTimeout(Timeout);
         }
      };
   }, []);
   if (isWeb && Loading) {
      return <SplashScreen />;
   }
   return (
      <NavigationContainer
         //linking={linking}
         documentTitle={{
            formatter: (options, route) =>
               `${options?.title ?? route?.name} - ${brand}`,
         }}
         fallback={<Text>Loading...</Text>}>
         {/* Conditional stack navigator rendering based on login state */}
         {isLoggedIn ? <AppNavigator /> : <AuthNavigator />}
      </NavigationContainer>
   );
};

export default AppRoute;
